var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "route-and-print" },
    [
      _vm.useRoute
        ? [
            _vm.checkPermission && !_vm.directMode && _vm.list.length <= 1
              ? _c(
                  "router-link",
                  {
                    staticStyle: { color: "#0000FF" },
                    attrs: { to: _vm.fullPath, tag: "a" },
                    nativeOn: {
                      click: function($event) {
                        return _vm.onClick()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.data[_vm.field]))]
                )
              : _vm.checkPermission && !_vm.directMode && _vm.list.length >= 2
              ? _vm._l(_vm.list, function(item, index) {
                  return _c(
                    "router-link",
                    {
                      key: item.uuid,
                      staticStyle: { color: "#0000FF" },
                      attrs: { to: _vm.fullPath, tag: "a" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.onClick(item)
                        }
                      }
                    },
                    [
                      _vm._v(" " + _vm._s(item[_vm.field])),
                      index < _vm.list.length - 1
                        ? _c("span", [_vm._v(",")])
                        : _vm._e()
                    ]
                  )
                })
              : _vm.directMode
              ? _c(
                  "el-link",
                  { attrs: { href: _vm.directFinalUrl, target: "_blank" } },
                  [_vm._v(_vm._s(_vm.data[_vm.field]))]
                )
              : _c(
                  "el-link",
                  {
                    staticStyle: { "font-size": "12px", color: "#0000FF" },
                    attrs: { type: "primary" },
                    on: { click: _vm.showMessage }
                  },
                  [_vm._v(_vm._s(_vm.data[_vm.field]))]
                )
          ]
        : _c("span", [_vm._v(_vm._s(_vm.data[_vm.field]))]),
      _vm.usePrint
        ? _c("i", {
            staticClass: "el-icon-search",
            staticStyle: {
              "margin-left": "5px",
              color: "#0000FF",
              cursor: "pointer"
            },
            on: { click: _vm.printMethod }
          })
        : _vm._e(),
      _c(
        "label",
        { staticStyle: { color: "#0000FF", "font-weight": "normal" } },
        [_vm._v(_vm._s(_vm.shortContent))]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }